import {FormioBase} from "./formiobase";

export class HiddenField extends FormioBase {
  public inputType = "hidden";
  public title = "Hidden";
  public icon = "fa fa-h-square";
  public schema: any = {
    title: "Hidden",
    components: [{
      type: "hidden",
      inputType: "hidden",
      key: "hidden",
      input: true,
      tableView: true,
      label: "hidden",
      customClass: "ds-hidden",
    }],
  };
}
